import React, { useState } from "react";
import {
  InputField,
  MyMessage,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { useCurrencyContext } from "../../context/CurrencyContext";
import { getOneCurrency } from "../../lib/sysNavigation/SysNavigation";
import { TbCurrencyDollar } from "react-icons/tb";

const Edit = () => {
  const { updateCurrencyState, updateCurrency } = useCurrencyContext();
  const currency = getOneCurrency();
  const currency_id = currency.currency_id;

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [title, setTitle] = useState(currency?.name);
  const [code, setCode] = useState(currency?.code);
  const [country, setCountry] = useState(currency?.country);
  const [exchangeRateToUsd, setExchangeRateToUsd] = useState(
    currency?.exchange_rate_to_usd
  );

  const currencyRoutes = "/currency";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  const responses = (isError: any, message: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const updateOneCurrencyHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!title || title === "") {
      setLoading(false);
      return responses(true, "Currency Name is Required");
    } else if (!code || code === "") {
      setLoading(false);
      return responses(true, "Currency Code is Required");
    } else if (!exchangeRateToUsd || exchangeRateToUsd === "") {
      setLoading(false);
      return responses(true, "Exchange Rate is Required");
    } else if (!country || country === "") {
      setLoading(false);
      return responses(true, "Country is Required");
    } else {
      await sendDBRequest();
    }
  };

  /**
   * @author Ntavigwa Bashombe
   * @param {*} thumbnail
   * @returns
   */
  const sendDBRequest = async () => {
    const data = {
      name: title,
      code: code,
      exchange_rate_to_usd: exchangeRateToUsd,
      country: country,
      status: 1,
    };

    const { status, message } = await updateCurrency(currency_id, data);
    if (status === 200) {
      updateCurrencyState({ currency_id, ...data });
      cleanFields();
      responses(false, message);
    } else {
      setLoading(false);
      responses(true, message);
    }
  };

  return (
    <AddPageShell
      backRoute={currencyRoutes}
      eyebrow="Catalog • Currencies"
      title="Edit Currency"
      subtitle="Updated the official currency, code, country and exchange rate to USD."
      icon={<TbCurrencyDollar className="h-5 w-5" />}
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneCurrencyHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage("");
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Currency Details"
        hint="The exchange rate is used to normalise pricing in dashboards."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
          <InputField
            props={{
              id: "title",
              title: "Currency Name",
              type: "text",
              required: true,
              value: title ? title : "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "code",
              title: "Currency Code",
              type: "text",
              required: true,
              value: code ? code : "",
              onChange: (e: any) => {
                setCode(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "exchange_rate",
              title: "Exchange Rate To USD",
              type: "number",
              required: true,
              value: exchangeRateToUsd ? exchangeRateToUsd : "",
              onChange: (e: any) => {
                setExchangeRateToUsd(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "country",
              title: "Country",
              type: "text",
              required: true,
              value: country ? country : "",
              onChange: (e: any) => {
                setCountry(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>
    </AddPageShell>
  );
};

export default Edit;
